import { Modal } from 'react-bootstrap';
import { Button, Label } from '../../atoms';
import styles from './OrganizationLandscapeSupporterModal.module.css';
import { FC } from 'react';
import { CustomDropdown } from '../../molecules';
import { LandscapeResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-response.dto';
import { LandscapeBuyerRelationType } from '../../../store/landscapeAPI/landscape/landscape-buyer-relation-type';
import { LandscapeSupportersSaveRequestDto } from '../../../store/tradeAPI/commodity/dto/request/landscape-suporters-save-request.dto';
import { LandscapeCommodityResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-commodity-response.dto';

interface OrganizationLandscapeSupporterModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  setSelectedLandscape: (id: string) => void;
  selectedLandscape: string | undefined;
  landscapes: LandscapeResponseDto[];
  commodities: LandscapeCommodityResponseDto[];
  landscapeSupporter: LandscapeSupportersSaveRequestDto;
  handleOnChange: (
    landscapeSupporter: LandscapeSupportersSaveRequestDto
  ) => void;
  callbackFn: (landscapeSupporter: LandscapeSupportersSaveRequestDto) => void;
}

const OrganizationLandscapeSupporterModal: FC<
  OrganizationLandscapeSupporterModalProps
> = ({
  show,
  setShow,
  setSelectedLandscape,
  selectedLandscape,
  landscapes,
  commodities,
  landscapeSupporter,
  handleOnChange,
  callbackFn,
}) => {
  const types = Object.values(LandscapeBuyerRelationType);
  const relationTypeItems = types.map((item) => ({
    eventKey: item,
    label: item,
  }));
  const landscapeItems = landscapes.map((item) => ({
    eventKey: item.id,
    label: item.name,
  }));
  const initialLandscapeItem = landscapeItems.find(
    (item) => item.eventKey === selectedLandscape
  )?.label;
  const commodityItems = commodities.map((item) => ({
    eventKey: item.id,
    label: item.name,
  }));

  return (
    <Modal centered show={show} onHide={() => setShow(false)}>
      <div className={styles.modal}>
        <Modal.Body className={styles.modalBody}>
          <Label
            content="Add Landscape (All Commodities)"
            className={styles.title}
          />
          <div className={styles.modalInput}>
            <label>Landscape</label>
            <CustomDropdown
              initialTitle={initialLandscapeItem ?? 'Please select a Landscape'}
              items={landscapeItems}
              onSelectOption={(e) => {
                setSelectedLandscape(e.eventKey);
                handleOnChange({
                  ...landscapeSupporter,
                  compactId: e.eventKey,
                });
              }}
            />
          </div>
          <div className={styles.modalInput}>
            <label>Commodity</label>
            <CustomDropdown
              initialTitle="Please select a Commodity"
              items={commodityItems}
              onSelectOption={(e) =>
                handleOnChange({
                  ...landscapeSupporter,
                  commodityId: e.eventKey,
                })
              }
            />
          </div>
          <div className={styles.modalInput}>
            <label>Relationship type</label>
            <CustomDropdown
              initialTitle={LandscapeBuyerRelationType.Funders}
              items={relationTypeItems}
              onSelectOption={(e) =>
                handleOnChange({
                  ...landscapeSupporter,
                  relationType: e.eventKey,
                })
              }
            />
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.modalButtons}>
          <Button
            onClick={() => callbackFn(landscapeSupporter)}
            className={styles.buttonBorder}
            variant="light"
          >
            Save
          </Button>
          <Button
            className={styles.buttonBorder}
            variant="light"
            onClick={() => setShow(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default OrganizationLandscapeSupporterModal;
